import {Component, OnInit} from '@angular/core';
import {ListContentComponent} from '../../../../shared/components/list-content/list-content.component';
import {MenuItemModel} from '../../../../shared/models/menu-item.model';
import {ActivatedRoute, Router} from '@angular/router';
import {PurchaseOrderService} from '../../../purchase-order/services/purchase-order-service';
import {InvoiceService} from '../../services/invoice.service';
import {ListContentModel} from '../../../../shared/models/list-content.model';
import {query, transition, trigger, useAnimation} from '@angular/animations';
import {slideIn50StaggerAnimation} from '../../../../shared/animation/common.animation';
import {faPencil} from '@fortawesome/free-solid-svg-icons';
import {ButtonTypeEnum, IspColoursEnum, SizeEnum} from '@i-supplier/angular-shared-module';
import {faPenToSquare} from '@fortawesome/pro-duotone-svg-icons';

@Component({
  selector: 'due-payments-to-generate',
  templateUrl: './due-payments-to-generate.component.html',
  styleUrls: ['./due-payments-to-generate.component.scss'],
  animations: [
    trigger('slideInStagger', [
      transition(':enter', [
        query('.slide-in-animation', [
          useAnimation(slideIn50StaggerAnimation)
        ], {optional: true})
      ])
    ])
  ]
})
export class DuePaymentsToGenerateComponent extends ListContentComponent implements OnInit {
  protected readonly faPencil = faPencil;
  protected readonly SizeEnum = SizeEnum;
  protected readonly faPenToSquare = faPenToSquare;
  protected readonly IspColoursEnum = IspColoursEnum;
  protected readonly ButtonTypeEnum = ButtonTypeEnum;

  constructor(
    public router: Router,
    public route: ActivatedRoute,
    private invoiceService: InvoiceService,
    private purchaseOrderService: PurchaseOrderService
  ) {
    super(router, route);
  }

  listParamValidator = {
    page: RegExp('^[1-9][0-9]*$'),
    size: ['5', '10', '20'],
    sort: RegExp('^(firstName|email|contact\.phones\.workPhoneNumber|accountingMonth)\,(asc|desc)$'),
    search: RegExp('.{3,}'),
  };
  menu: MenuItemModel[] = [];
  requestBlocked: string[] = [];

  ngOnInit(): void {
    this.sort = 'accountingMonth';
    this.sortDirection = 'asc';
    super.ngOnInit();
    this.subscribeToQueryParam();
  }

  retrieveListContent(params: any): void {
    const page = params.page ? params.page - 1 : 0;
    const size = 2000;
    const sort = params.sort ? params.sort : 'id,asc';
    const search = params.search ? params.search : null;
    this.invoiceService.getDuePaymentsWaitingForGeneration(page, size, sort, search).subscribe({
      next: (res: ListContentModel) => {
        this.listContent = res.content;
        this.totalElements = res.totalElements;
        this.numberOfElements = res.numberOfElements;
        this.isListEmpty = !this.isSearchActive && res.empty;
        Array.from(new Set(this.listContent.map((activitySheet) => activitySheet.requestId))).forEach((requestId) => {
          this.purchaseOrderService.getPurchaseOrdersWaitingForRequest(requestId).subscribe(value => {
            if (value) {
              this.requestBlocked.push(requestId);
            }
          });
        });
        if (res.totalPages !== 0 && params.page > res.totalPages) {
          this.updateQueryParam({page: res.totalPages});
        }
        this.firstCallDone = true;
      }
    });
  }

  generateInvoice(duePayment: any) {
    this.router.navigate(['/accounting/due-payment/', duePayment.id, 'proforma-generation']);
  }
}
